import { render, staticRenderFns } from "./Watchdetail-child2.vue?vue&type=template&id=3c306162&scoped=true"
import script from "./Watchdetail-child2.vue?vue&type=script&lang=js"
export * from "./Watchdetail-child2.vue?vue&type=script&lang=js"
import style0 from "./Watchdetail-child2.vue?vue&type=style&index=0&id=3c306162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c306162",
  null
  
)

export default component.exports